var mixins = {
  mounted () {
    let token = sessionStorage.getItem("token") || ''
    if(token == ''){
      this.$router.push({ name: 'login' })
      return false
    } 
    return token
  },
  computed: {
    userData () {
      return JSON.parse(sessionStorage.getItem('user') || '{}')
    },

  },
  filters: {
    percent (val) {
      return `${(val * 100).toFixed(2)}%`
    }
  },
  methods: {
    number (str) {
      str = parseInt(str);
      if(isNaN(str))return null;
      return str
    },
    delay (time) {
      return new Promise((resolve, reject) => {
        clearTimeout(this.delayStatus);
        this.delayStatus = setTimeout(() => {
          resolve();
        }, parseInt(time))
      })
    },
    getPermission(menuName) {
      let d = JSON.parse(sessionStorage.getItem('permission')).filter(n=>n.parentName == menuName)//从缓存的permission中筛选出当前选项卡的权限
      return d
    },
    permissionChecker(permissionName) {
      return JSON.parse(sessionStorage.getItem('permission')).filter(n=>n.name == permissionName).length>0;
    },
    featureChecker(featureName) {
      return JSON.parse(sessionStorage.getItem('features')).filter(n=>n == featureName).length>0;
    }
  }
}
export default mixins



// WEBPACK FOOTER //
// ./src/mixins/account.js